<div class="flex flex-col min-h-screen bg-slate-50 mx-2">
  <ng-content></ng-content>
  <main class="flex-grow flex flex-col items-center">
    <div
      class="element-container p-6 bg-white border border-slate-200 rounded-xl shadow-sm font-sans w-fit min-w-full md:min-w-2xl"
    >
      <div class="mb-6">
        <div class="flex justify-between items-center mb-2">
          <span class="ml-auto text-xs font-semibold inline-block text-blue-600"
            >{{ page()?.progress }}%</span
          >
        </div>
        <div class="overflow-hidden h-2 text-xs flex rounded bg-slate-100">
          <div
            [style.width.%]="page()?.progress"
            class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-500 transition-all duration-500"
          ></div>
        </div>
      </div>

      @for (item of page()?.elements; track item.id) {
      <lib-element
        [element]="item"
        [id]="item.id"
        [attr.data-element-name]="item.name"
      ></lib-element>
      }

      <div
        class="flex justify-between items-center mt-4 pt-4 border-t border-slate-100"
      >
        <div>
          @if(page()?.navigation?.showBackwardButton) {
          <button
            (click)="goBack()"
            class="flex items-center justify-center p-2 rounded-full text-slate-500 hover:bg-slate-100 transition-colors duration-200 focus:outline-none"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2.5"
              stroke="currentColor"
              class="w-5 h-5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.75 19.5L8.25 12l7.5-7.5"
              />
            </svg>
          </button>
          }
        </div>
        <button
          type="button"
          (click)="goForward()"
          class="inline-flex items-center px-5 py-2.5 text-sm font-bold text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors duration-200 shadow-sm focus:outline-none focus:ring-4 focus:ring-blue-200 disabled:opacity-50 disabled:cursor-not-allowed"
          [disabled]="!isValid()"
        >
          Next
        </button>
      </div>
    </div>
    @for (pageContainer of [page().id]; track pageContainer) {
    <div class="page-plugin-layer">
      @for (plugin of pagePlugins(); track plugin.usageId) {
      <lib-plugin-host #pluginRef [pluginDef]="plugin"></lib-plugin-host>
      }
    </div>
    }
  </main>
</div>
